export const waitForMs = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const getScrambledArray = <T>(original: T[]): T[] => {
  const source = [...original];
  const scrambled: T[] = [];

  while (source.length > 0) {
    const randomIndex = Math.floor(Math.random() * source.length);
    const [pickedValue] = source.splice(randomIndex, 1);

    scrambled.push(pickedValue);
  }

  return scrambled;
};

export const isEven = (num: number): boolean => num % 2 === 0;

export const isOdd = (num: number): boolean => !isEven(num);

export const interpolate = (
  x: number,
  ranges: { input: [number, number]; output: [number, number] }
): number => {
  const [x1, x2] = ranges.input;
  const [y1, y2] = ranges.output;

  const m = (y2 - y1) / (x2 - x1);
  return m * (x - x1) + y1;
};

export function getParagraphs(text: string) {
  if (!text) {
    return [];
  }
  const removedDoubledLines = text.replace(/\n\n+/g, '\n');

  return removedDoubledLines?.split('\n') ?? [];
}

export function calculateColumnsInScreen(
  screenWidth: number,
  columnWidth: number,
  columnGap: number
): number {
  const availableWidth = screenWidth - columnWidth;
  return Math.floor(availableWidth / (columnWidth + columnGap)) + 1;
}

// a function that takes as input an array of items and distributes them into a two-dimensional array of specific column number. It fills last line with value 'null'
export function distributeItemsInExistingArray<T>(
  items: T[][],
  twoDimensionalArray: T[][],
  gapFiller?: () => T
): T[][] {
  const columnCount = twoDimensionalArray.length;

  items.forEach((item, index) => {
    twoDimensionalArray[index % columnCount].push(...item);
  });

  if (gapFiller) {
    const tableHeight = Math.max(
      ...twoDimensionalArray.map((column) => column.length)
    );
    twoDimensionalArray.forEach((column) => {
      if (column.length < tableHeight) {
        column.push(gapFiller());
      }
    });
  }

  return twoDimensionalArray;
}

// a function that takes as input an array of items and distributes them into a two-dimensional array of specific column number. It creates the two-dimensional array.
export function distributeItemsIntoColumns<T>(
  items: T[][],
  columnCount: number,
  gapFiller?: () => T
): T[][] {
  const twoDimensionalArray: T[][] = new Array(columnCount)
    .fill(null)
    .map(() => []);

  return distributeItemsInExistingArray(items, twoDimensionalArray, gapFiller);
}

export function createUid(): string {
  return Math.random().toString(36).substring(2, 11);
}
